<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-1">Edit Attachment</p>
  <p class="text-sm text-[var(--tertiary-text)] mb-5">Edit the current attached file.</p>

  <form [formGroup]="updateAttachmentForm">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>File Description</mat-label>
      <input matInput oninput="if (this.value.length > 100) this.value = this.value.slice(0, 100);" formControlName="description">
    </mat-form-field>

    <div class="bg-[var(--app-base)] rounded-lg px-4 py-3 mb-4">
      <div class="flex items-center text-[12px]">
        <span class="font-bold text-[var(--base-text-alt-dark)] mr-1.5">File description:</span>
        <span class="text-[var(--tertiary-text)]">{{fileName}}</span>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-4">
      <button (click)="cancelUpdatingAttachment()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
      <button (click)="updateOrderAttachment()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Update</button>
    </div>
  </form>
</div>
